// extracted by mini-css-extract-plugin
export var WorkWithUs = "index-module--WorkWithUs--sQQzX";
export var blackBG = "index-module--blackBG--LzGH7";
export var cls1 = "index-module--cls1--6hnI8";
export var cls2 = "index-module--cls2--VSK5M";
export var cls3 = "index-module--cls3--dFC5b";
export var cls4 = "index-module--cls4--JNjZR";
export var contactIcon = "index-module--contactIcon--9eoz6";
export var nextSectionBtn = "index-module--nextSectionBtn--oZj5B";